<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="aboutUs">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent />
						<span @click="toTopImg()">首页</span>
						<span class="arrow">></span>
						<span @click="barClick(0)">关于我们</span>
						<span class="arrow">></span>
						<span v-if="list[count] && list[count].menuName">{{ list[count].menuName }}</span>
					</div>
				</div>
				<div class="tabbar">
					<div class="item" @click="barClick(index)" :class="{ active: count == index }" v-for="(item, index) in list">
						<div class="txt">{{ item.menuName }}</div>
						<div class="line"></div>
					</div>
				</div>
				<div class="card">
					<!-- 富文本 -->
					<div v-if="count == 0 || count == 1" class="rich" v-html="formatRichText(text)"></div>
					<!-- 科研平台 -->
					<div v-else-if="count == 1" class="keyanpingtai-list">
						<div class="keyanpingtai-item" v-for="(item, index) in kyptData" :key="item.id">
							<img src="../assets/fangge.png" alt="" @dragstart.prevent />
							<div class="description txt-ellipsis-1">{{ filterUnit(item.contentTitle) }}</div>
							<div class="time" v-if="item.createTime">[{{ item.createTime.slice(0, 10) }}]</div>
						</div>
					</div>
					<div class="certificate-list" v-else-if="count == 3">
						<div class="item" v-for="(item, index) in snckData">
							<img :src="webImg + item.contentImg + imgCut(305, 381)" alt="" @dragstart.prevent />
							<div v-if="item.contentTitle">{{ item.contentTitle }}</div>
						</div>
					</div>
					<div class="keyanchengguo" v-else-if="count == 4">
						<div class="rich" v-html="formatRichText(text)"></div>
						<div class="keyanchengguo-table">
							<el-table :data="kycgData" style="width: 100%">
								<el-table-column prop="date" label="序号" width="180">
									<template slot-scope="scope">
										<div class="serial">
											<div class="serial-content">{{ scope.$index + 1 < 10 ? `0${scope.$index + 1}` : scope.$index + 1 }}</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="contentTitle" label="项目名称" width="180"></el-table-column>
								<el-table-column prop="awardLevel" label="级别" width="180">
									<template slot-scope="scope">
										<div class="awardLevel">
											{{award_level.find(v => v.dictValue == scope.row.awardLevel).dictLabel}}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="awardGrade" label="等级" width="180">
									<template slot-scope="scope">
										<div class="awardLevel">
											{{award_grade.find(v => v.dictValue == scope.row.awardGrade).dictLabel}}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="contentTime" label="获奖时间"></el-table-column>
							</el-table>
						</div>
						<div v-if="kycgData.length > 0" style="height: 130px; display: flex; align-items: center; justify-content: center">
							<el-pagination layout="prev, pager, next" :total="total" background :page-size="pageSize" @current-change="handleCurrentChange"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="device-pc" v-else>
			<div class="aboutUs">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent />
						<span @click="toTopImg()" style="cursor: pointer">首页</span>
						<span style="color: black">></span>
						<span @click="barClick(0)">关于我们</span>
						<span style="color: black">></span>
						<span v-if="list[count] && list[count].menuName">{{ list[count].menuName }}</span>
					</div>
				</div>
				<div class="main">
					<div class="left">
						<div class="top">关于我们</div>
						<div v-for="(item, index) in list" class="bar" :class="{ bar1: count == index }" @click="barClick(index)">{{ item.menuName }}</div>
					</div>
					<!-- 企业介绍、标委会 -->
					<div v-if="count == 0 || count == 1" class="right ftRight" v-html="formatRichText(text)"></div>
					<!-- 科研平台 -->
					<div v-else-if="count == 1" class="keyanpingtai">
						<div class="heading">研发与检测平台</div>
						<div class="line"></div>
						<div class="keyanpingtaiList">
							<div class="keyanpingtaiItem" v-for="(item, index) in kyptData" :key="item.id">
								<img src="../assets/fangge.png" alt="" @dragstart.prevent />
								<div class="description txt-ellipsis-1">{{ filterUnit(item.contentTitle) }}</div>
								<div class="time" v-if="item.createTime">[{{ item.createTime.slice(0, 10) }}]</div>
							</div>
						</div>
						<div v-if="kyptData.length > 0" style="height: 130px; display: flex; align-items: center; justify-content: center">
							<el-pagination layout="prev, pager, next" :total="total" background :page-size="pageSize" @current-change="handleCurrentChange"></el-pagination>
						</div>
					</div>
					<!-- 荣誉 -->
					<div v-else-if="count == 3" class="right" style="padding: 0">
						<div style="width: 92%; border-bottom: 1px solid #ededed; display: flex; cursor: pointer; margin: 0 auto; margin-top: 10px">
							<div
								@click="(contentType = index + 1), barClick(3)"
								class="typeStyle"
								:class="{ typeStyle1: contentType == index + 1 }"
								v-for="(item, index) in typeList"
								:key="index"
							>
								{{ item }}
							</div>
						</div>
						<div class="rightMain">
							<div class="rightMainItem" v-for="(item, index) in snckData">
								<img :src="webImg + item.contentImg + imgCut(240, 300)" alt="" @dragstart.prevent style="border: 0.5px solid #e5e5e5" />
								<div v-if="item.contentTitle">{{ item.contentTitle }}</div>
							</div>
						</div>
						<div v-if="snckData.length > 0" style="height: 130px; display: flex; align-items: center; justify-content: center">
							<el-pagination layout="prev, pager, next" :total="total" background :page-size="pageSize" @current-change="handleCurrentChange"></el-pagination>
						</div>
					</div>
					<!-- 科研成果 -->
					<div class="keyanchengguo" v-else-if="count == 4" style="padding: 0">
						<div class="ftRight" v-html="formatRichText(text)"></div>
						<div class="keyanchengguo-table">
							<el-table :data="kycgData" style="width: 100%">
								<el-table-column prop="date" label="序号" width="180">
									<template slot-scope="scope">
										<div class="serial">
											<div class="serial-content">{{ scope.$index + 1 < 10 ? `0${scope.$index + 1}` : scope.$index + 1 }}</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="contentTitle" label="项目名称" width="180"></el-table-column>
								<el-table-column prop="awardLevel" label="级别" width="180">
									<template slot-scope="scope">
										<div class="awardLevel">
											{{award_level.find(v => v.dictValue == scope.row.awardLevel).dictLabel}}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="awardGrade" label="等级" width="180">
									<template slot-scope="scope">
										<div class="awardLevel">
											{{award_grade.find(v => v.dictValue == scope.row.awardGrade).dictLabel}}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="contentTime" label="获奖时间"></el-table-column>
							</el-table>
						</div>
						<div v-if="kycgData.length > 0" style="height: 130px; display: flex; align-items: center; justify-content: center">
							<el-pagination layout="prev, pager, next" :total="total" background :page-size="pageSize" @current-change="handleCurrentChange"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { menu, singleinfo, contentList, contentPage, DictList } from '../api/api';
var num = 0;
export default {
	name: 'aboutUsTemplate',
	data() {
		return {
			parentId: this.$route.query.parentId || '', //二级菜单数组id
			list: [], //二级菜单数组
			text: '', //富文本内容
			count: 0,
			colNum: 0,
			rowNum: 0,
			data: '',
			snckData: [],
			pageNum: 1,
			pageSize: 9,
			total: 0,
			menuId: '',
			isShow1: -1,
			interval: null,
			search: '',
			contentSort: '',
			type: '',
			img: '',
			contentType: 1,
			typeList: ['公司资质', '公司荣誉'],
			typeCount: 0,
			keyanchengguoTypeList: ['国家科技进步奖', '省部科技进步奖', '其它奖项'],
			tableData: [
				{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				},
				{
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				},
				{
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}
			],
			// 科研平台数据
			kyptData: [],
			// 科研成果数据
			kycgData: [],
			// 获奖级别
			award_level: '',
			// 获奖等级
			award_grade: '',
			// 级别选项
			awardLevel: ''
		};
	},
	mounted() {
		if (this.isMobile) {
			this.pageSize = 10;
			this.$bus.$on('reachBottom', (data) => {
				if (this.count == 3) {
					if (this.snckData.length && this.pageNum * this.pageSize < this.total) {
						this.pageNum++;
						this.getContentList(this.list[this.count].menuId, this.count);
					} else {
						this.$message({
							message: '没有更多了~',
							center: true,
							offset: window.screen.height / 2
						});
					}
				}
			});
		} else {
		}
		window.addEventListener('scroll', this.handleScroll, true);
	},
	beforeDestroy() {
		this.$bus.$off('reachBottom');
		clearInterval(this.interval);
	},
	created() {
		this.getList(); //二级菜单数组
		this.getDictList('award_level');
		this.getDictList('award_grade');
	},
	watch: {
		$route(to, from) {
			this.count = to.query.num;
			this.barClick(to.query.num);
		}
	},
	methods: {
		// 根据字典类型获取字典数据
		getDictList(dictType) {
			DictList(dictType).then((res) => {
				this[dictType] = res.data;
			});
		},
		filterUnit(item) {
			return item.replace(/<br>/g, '');
		},

		handleScroll() {
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > 240 + (this.isShow1 / 2) * 290 && this.isShow1 % 2 == 0 && new Date().getTime() - num > 1000) {
				if (this.isShow1 % 2 == 0) {
					this.isShow1++;
					setTimeout(() => {
						this.isShow1++;
						num = new Date().getTime();
					}, 2000);
				}
			}
		},
		//首页
		toTopImg() {
			this.$router.push({
				path: '/home',
				query: {
					index: 0
				}
			});
		},
		//二级菜单数组
		getList() {
			menu(this.parentId).then((res) => {
				this.list = res.data;
				console.log(this.$route.query.num, 'this.$route.query.num');
				if (this.$route.query.num == 0 || this.$route.query.num == 1) {
					this.count = this.$route.query.num;
					this.getSingleinfo(res.data[this.$route.query.num].cmsLink); //富文本
				}
				// if (this.$route.query.num == 1 || this.$route.query.num == 3) {
				// 	this.count = this.$route.query.num;
				// 	this.getContentList(res.data[this.$route.query.num].menuId, this.$route.query.num);
				// }
				// if (this.$route.query.num == 4) {
				// 	this.count = this.$route.query.num;
				// 	this.getSingleinfo(res.data[this.$route.query.num].cmsLink); //富文本
				// 	this.getContentList(res.data[this.$route.query.num].menuId, this.$route.query.num);
				// }
				if (!this.$route.query.num) {
					this.getSingleinfo(res.data[0].cmsLink); //富文本
				}
			});
		},
		//富文本
		getSingleinfo(id) {
			singleinfo(id).then((res) => {
				this.text = res.data.content;
				console.log(res, 'getSingleinfo');
			});
		},
		//菜单点击
		barClick(index) {
			this.count = index;
			console.log('this.count: ', this.count);
			this.pageNum = 1;
			// 企业介绍、标委会
			if (index == 0 || index == 1) {
				this.getSingleinfo(this.list[index].cmsLink); //富文本
			} else if (index == 1 || index == 3) {
				// 科研平台、资质荣誉
				this.getContentList(this.list[index].menuId, index);
			} else if (index == 4) {
				// 科研成果
				this.getSingleinfo(this.list[index].cmsLink); //富文本
				this.getContentList(this.list[index].menuId, index);
			}
		},
		getContentList(menuId, index) {
			this.isShow1 = -1;
			num = 1;
			// 企业介绍
			if (index == 1) {
				this.menuId = menuId;
				contentPage(this.pageNum, this.pageSize, menuId, this.search, this.contentSort, this.type, this.img, this.contentType, this.awardLevel).then((res) => {
					if (!this.isMobile) {
						this.kyptData = res.data;
					} else {
						if (this.pageNum == 1) {
							this.kyptData = res.data;
						} else {
							this.kyptData = this.kyptData.concat(res.data);
						}
					}
					this.total = res.total;
				});
			} else if (index == 3) {
				// 资质荣誉
				this.menuId = menuId;
				contentPage(this.pageNum, this.pageSize, menuId, this.search, this.contentSort, this.type, this.img, this.contentType, this.awardLevel).then((res) => {
					if (!this.isMobile) {
						this.snckData = res.data;
					} else {
						if (this.pageNum == 1) {
							this.snckData = res.data;
						} else {
							this.snckData = this.snckData.concat(res.data);
						}
					}
					this.total = res.total;
				});
			} else if (index == 4) {
				// 科研成果
				this.menuId = menuId;
				contentPage(this.pageNum, this.pageSize, menuId, this.search, this.contentSort, this.type, this.img, this.contentType, this.awardLevel).then((res) => {
					if (!this.isMobile) {
						this.kycgData = res.data;
					} else {
						if (this.pageNum == 1) {
							this.kycgData = res.data;
						} else {
							this.kycgData = this.kycgData.concat(res.data);
						}
					}
					this.total = res.total;
					this.$forceUpdate()
				});
			}
		},
		handleCurrentChange(e) {
			contentPage(e, this.pageSize, this.menuId, this.search, this.contentSort, this.type, this.img, this.contentType, this.awardLevel).then((res) => {
				this.snckData = res.data;
				this.total = res.total;
			});
		},
		formatRichText(html) {
			//控制富文本图片大小
			let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
				match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
				// match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
				// match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
				return match;
			});
			newContent = newContent.replace(/style="[^"]+"/gi, function (match, capture) {
				match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
				return match;
			});
			newContent = newContent.replace(/<br[^>]*\/>/gi, '');

			newContent = newContent.replace(/\<img/gi, '<img style="max-width:95%;height:auto;display:inline-block;margin:10rpx auto;text-indent: 0;"');

			return newContent;
		}
	}
};
</script>

<style scoped lang="scss">
.device-mobile {
	.aboutUs {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 9.466667rem;
		margin-bottom: 1.466667rem;

		// background: #F5F5F5;
		.navigation {
			width: 100%;
			// background: #F5F5F5;
			padding: 0 0.333333rem;

			.navigationItem {
				display: flex;
				align-items: center;
				padding-top: 0.36rem;
				// height: 1.066667rem;
				color: #1979b7;
				font-size: 0.333333rem;

				.arrow {
					color: #030303;
					margin: 0 0.133333rem;
				}

				img {
					width: 0.333333rem;
					height: 0.333333rem;
					margin-right: 0.133333rem;
				}
			}
		}

		.tabbar {
			width: 100%;
			height: 1.653333rem;
			display: flex;
			align-items: center;

			.item {
				position: relative;
				display: flex;
				flex-direction: column;
				margin-right: 0.3rem;

				&.active {
					.txt {
						font-size: 0.453333rem;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: bold;
						color: #000000;
					}

					.line {
						display: block;
					}
				}

				.txt {
					font-size: 0.4rem;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #000000;
				}

				.line {
					position: absolute;
					bottom: -0.266667rem;
					display: none;
					margin-top: 0.213333rem;
					width: 1.2rem;
					height: 0.053333rem;
					background: #007cc3;
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
				}
			}
		}

		.card {
			width: 100%;
			box-shadow: 0px 0px 0.32rem 0px rgba(0, 0, 0, 0.1);
			border-radius: 0px 0px 0px 0px;
			opacity: 1;

			.rich {
				background: #ffffff;
				padding: 10px;
				box-sizing: border-box;
				font-size: 0.213333rem;
				// font-size: 0.213333rem;

				p img {
					text-indent: 0 !important;
				}
			}

			.development-history {
				width: 100%;
				box-sizing: border-box;
				padding: 0.533333rem;

				.date-range {
					width: 2.666667rem;
					height: 0.853333rem;
					margin-bottom: 0.8rem;
					background: #0175c2;
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
					font-size: 0.4rem;
					font-family: Microsoft YaHei-Regular, Microsoft YaHei;
					font-weight: 400;
					color: #ffffff;
					line-height: 0.853333rem;
					text-align: center;
				}

				.list {
					.item {
						display: flex;

						.left {
							position: relative;
							display: flex;
							flex-direction: column;
							align-items: center;
							margin-right: 0.4rem;

							.square {
								width: 0.32rem;
								height: 0.32rem;
								background: #ffffff;
								box-shadow: 0px 0.053333rem 0.053333rem 0px rgba(5, 89, 187, 0.25);
								border-radius: 0px 0px 0px 0px;
								opacity: 1;
								box-sizing: border-box;
								border: 0.053333rem solid #0175c2;
							}

							.line {
								width: 0.053333rem;
								height: 100%;
								background-color: #0175c2;
								opacity: 1;
							}
						}

						.right {
							.title {
								font-size: 0.373333rem;
								font-family: Microsoft YaHei-Regular, Microsoft YaHei;
								font-weight: 400;
								color: #000000;
								line-height: 0.373333rem;
							}

							.description {
								font-size: 0.32rem;
								font-family: Microsoft YaHei-Regular, Microsoft YaHei;
								font-weight: 400;
								color: #666666;
								// line-height: 0.32rem;
								padding: 0.266667rem 0;
								min-height: 1.333333rem;
								box-sizing: border-box;
							}
						}
					}
				}
			}

			.certificate-list {
				width: 100%;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;

				.item {
					margin-bottom: 0.266667rem;
					width: 4.6rem;
					// height: 6.493333rem;
					// background: #FFFFFF;
					box-shadow: 0px 0px 0.32rem 0px rgba(0, 0, 0, 0.1);
					border-radius: 0px 0px 0px 0px;
					opacity: 1;
					box-sizing: border-box;
					padding: 0.266667rem 0.266667rem 0;

					img {
						width: 100%;
						height: 5.066667rem;
						// max-height: 5.066667rem;
						// background-color: #d3d8de;
						object-fit: contain;
					}

					div {
						width: 100%;
						height: 1.146667rem;
						display: flex;
						justify-content: center;
						align-items: center;
						font-size: 0.346667rem;
						font-family: Microsoft YaHei-Regular, Microsoft YaHei;
						font-weight: 400;
						color: #333333;
						// line-height: 1.146667rem;
						text-align: center;
					}
				}
			}

			// 科研平台
			.keyanpingtai-list {
				width: 100%;
				display: flex;
				flex-direction: column;

				.keyanpingtai-item {
					margin-bottom: 0.266667rem;
					width: 100%;
					box-sizing: border-box;
					padding: 0.266667rem 0.266667rem 0;
					display: flex;
					align-items: center;
					img {
						width: 0.373333rem;
						height: 0.373333rem;
						// max-height: 5.066667rem;
						// background-color: #d3d8de;
						object-fit: contain;
					}

					.description {
						flex: 1;
						font-size: 0.346667rem;
						color: #333333;
						padding: 0 0.266667rem;
					}
					.time {
						font-size: 0.346667rem;
						color: #333333;
					}
				}
			}
			
			// 科研成果
			.keyanchengguo {
				width: 100%;
				display: flex;
				flex-direction: column;
				.rich {
					background: #ffffff;
					padding: 10px;
					box-sizing: border-box;
					font-size: 0.426667rem;
					line-height: 2;
					// font-size: 0.213333rem;
					text-indent: 24pt;
					
					p img {
						text-indent: 0 !important;
					}
				}
				
				.nav {
					width: 100%;
					display: flex;
					margin: 0 auto;
					justify-content: center;
					align-items: center;
				
					img {
						width: 21px;
						height: 25px;
						cursor: pointer;
					}
				
					.navMain {
						width: 100%;
						display: flex;
						flex-wrap: wrap;
				
						.navMainItem {
							// width: 204px;
							min-width: 1.76rem;
							height: 0.853333rem;
							background: #0175c2;
							border-radius: 0px 0px 0px 0px;
							opacity: 1;
							margin-right: 0.133333rem;
							margin-bottom: 0.266667rem;
							box-sizing: border-box;
							padding: 0.133333rem;
				
							font-size: 0.373333rem;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #ffffff;
						}
				
						.navMainItem1 {
							background: #0175c2;
						}
					}
				}
				
				.keyanchengguo-table {
					width: 92%;
					margin: 0 auto;
					margin-top: 15px;
					.serial {
						display: flex;
						.serial-content {
							display: inline-block;
							// width: 27px;
							padding: 0 5px;
							height: 20px;
							background: #E5ECF2;
							border-radius: 6px 6px 6px 6px;
							font-weight: 500;
							font-size: 14px;
							color: #0076BE;
							line-height: 20px;
						}
					}
				}
			}
			
		}
	}
}

.device-pc {
	.aboutUs {
		width: 100%;
		// display: flex;
		// justify-content: center;
		background: #f5f5f5;
		padding-bottom: 50px;
	}

	.main {
		display: flex;
		margin: 0 auto;
		width: 1300px;
		// padding-top: 25px;
	}

	.left {
		// background: #FFFFFF;

		.top {
			width: 270px;
			height: 64px;
			background: url('../assets/bannerImg.png') no-repeat;
			background-size: 100%;
			font-size: 26px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #ffffff;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.bar {
			width: 270px;
			height: 48px;
			background: #ffffff;
			border-bottom: 1px solid #ededed;
			font-size: 18px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #333333;
			display: flex;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;
			cursor: pointer;
		}

		.bar1 {
			font-size: 18px;
			font-family: Microsoft YaHei-Bold, Microsoft YaHei;
			font-weight: bold;
			color: #0175c2;
			border-bottom: 1px solid #0175c2;
		}
	}

	.right {
		width: 100%;
		margin-left: 10px;
		min-height: 600px;
		background: #ffffff;
		padding: 10px;
		box-sizing: border-box;
	}

	.keyanpingtai {
		width: 100%;
		margin-left: 10px;
		min-height: 600px;
		background: #ffffff;
		padding: 40px 60px 10px;
		box-sizing: border-box;
		.heading {
			font-weight: bold;
			font-size: 36px;
			color: #000000;
			line-height: 36px;
			text-align: justify;
		}
		.line {
			margin-top: 40px;
			width: 61px;
			height: 5px;
			background: #0175c2;
			border-radius: 0px 0px 0px 0px;
		}
		.keyanpingtaiList {
			display: flex;
			flex-direction: column;
			margin-top: 20px;
			.keyanpingtaiItem {
				display: flex;
				align-items: center;
				padding: 14px 0;
				img {
					width: 14px;
					height: 14px;
				}
				.description {
					flex: 1;
					padding: 0 10px;
					font-weight: 500;
					font-size: 18px;
					color: #000000;
					line-height: 36px;
				}
				.time {
					font-weight: bold;
					font-size: 13px;
					color: #000000;
					line-height: 15px;
				}
			}
		}
	}

	// 科研成果
	.keyanchengguo {
		width:100%;
		margin-left: 10px;
		min-height: 600px;
		background: #ffffff;
		padding: 40px 60px 10px;
		box-sizing: border-box;
		.ftRight {
			margin: 0 auto;
			width: 92%;
			margin-top: 35px;
			margin-bottom: 35px;
		}
		.keyanchengguo-table {
			width: 92%;
			margin: 0 auto;
			margin-top: 15px;
			.serial {
				display: flex;
				.serial-content {
					display: inline-block;
					// width: 27px;
					padding: 0 5px;
					height: 20px;
					background: #E5ECF2;
					border-radius: 6px 6px 6px 6px;
					font-weight: 500;
					font-size: 14px;
					color: #0076BE;
					line-height: 20px;
				}
			}
		}
	}

	.ftRight {
		p img {
			text-indent: 0 !important;
		}
	}

	.rightMain {
		display: flex;
		flex-wrap: wrap;
		padding-bottom: 20px;
		// justify-content: space-between;

		.rightMainItem {
			font-size: 18px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #333333;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin-top: 50px;
			margin-left: 52px;
			cursor: pointer;
			overflow: hidden;
		}

		// .rightMainItem:hover {

		//     // transform: scaleX(20%);
		//     img {
		//         transition: transform 2s cubic-bezier(.23, 1, .32, 1);
		//         transform: scale(1.1);
		//     }
		// }

		img {
			width: 240px;
			height: 300px;
			margin-bottom: 20px;
			box-shadow: 0 0 16px 5px #e0dedf;
			// transition: transform 2s cubic-bezier(.23, 1, .32, 1);
		}
	}

	/* html,body{
		height: 100%;
		padding:0px;
		margin: 0px;
		overflow: auto;
	} */

	.mainSnakLine {
		width: 558px;
		height: 2px;
		margin: 0 auto;
		margin-bottom: 290px;
		position: relative;
		display: flex;
		justify-content: space-around;
	}

	.mainSnakLine0 {
		width: 558px;
		height: 2px;
		background: #f4f4f4;
		position: absolute;
		top: 0px;
		left: 0px;
	}

	.mainSnakLine1 {
		width: 558px;
		height: 2px;
		background: #0175c2;
		position: absolute;
		top: 0px;
		left: 0px;
		animation: widthAni 2s linear infinite alternate;
		animation-iteration-count: 1;
	}

	.mainSnakLine2 {
		width: 558px;
		height: 2px;
		background: #0175c2;
		position: absolute;
		top: 0px;
		right: 0px;
		animation: widthAni 2s linear infinite alternate;
		animation-iteration-count: 1;
	}

	.mainBoxRight {
		position: absolute;
		width: 144px;
		height: 290px;
		border: 2px solid #0175c2;
		border-radius: 0 144px 144px 0;
		border-left: none;
		top: 0;
		right: -135px;
	}

	.mainBoxRight0 {
		position: absolute;
		width: 144px;
		height: 290px;
		border: 2px solid #f4f4f4;
		border-radius: 0 144px 144px 0;
		border-left: none;
		top: 0;
		right: -135px;
	}

	.mainBoxRight1 {
		position: absolute;
		width: 144px;
		height: 0px;
		background-color: #ffffff;
		bottom: -292px;
		z-index: 1;
		right: -135px;
		animation: heightAni 1s linear infinite alternate;
		animation-iteration-count: 1;
	}

	.mainBoxLeft0 {
		position: absolute;
		width: 144px;
		height: 290px;
		border: 2px solid #f4f4f4;
		border-radius: 144px 0 0 144px;
		border-right: none;
		top: 0;
		left: -135px;
	}

	.mainBoxLeft {
		position: absolute;
		width: 144px;
		height: 290px;
		border: 2px solid #0175c2;
		border-radius: 144px 0 0 144px;
		border-right: none;
		top: 0;
		left: -135px;
	}

	.mainBoxLeft1 {
		position: absolute;
		width: 144px;
		height: 0px;
		background-color: #ffffff;
		bottom: -292px;
		z-index: 1;
		left: -135px;
		animation: heightAni 1s linear infinite alternate;
		animation-iteration-count: 1;
	}

	@keyframes widthAni {
		from {
			width: 0px;
		}

		to {
			width: 558px;
		}
	}

	@keyframes heightAni {
		from {
			height: 294px;
		}

		to {
			height: 0px;
		}
	}

	.mianBox {
		width: 12px;
		height: 12px;
		background: #ffffff;
		box-shadow: 0px 4px 4px 0px rgba(5, 89, 187, 0.25);
		border: 2px solid #0175c2;
		margin-top: -6px;
		position: relative;

		.mianBoxTitle {
			position: absolute;
			font-size: 36px;
			margin-bottom: 28px;
			// text-align: center;
			font-weight: bold;
			top: -60px;
			left: -50px;
		}

		.mianBoxDescription {
			position: absolute;
			top: 30px;
			left: 50%;
			width: 200px;
			// overflow: hidden;
			transform: translate(-50%, 0%);
			display: flex;
			justify-content: center;
			align-items: center;
			// text-align: center;
			color: #666;
			font-size: 17px !important;
		}
	}

	.mainBoxData {
		position: absolute;
		left: -150px;
		top: -86px;
		width: 200px;
		height: 88px;
		background: #0175c2;
		font-size: 30px;
		font-family: Microsoft YaHei-Regular, Microsoft YaHei;
		font-weight: 400;
		color: #ffffff;
		border-bottom: 1px solid #0175c2;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.navigation {
		// width: 100vw;
		background: #f5f5f5;
		display: flex;
		align-items: center;
		cursor: pointer;

		.navigationItem {
			width: 1300px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			// margin-top: 15px;
			height: 36px;
			line-height: 36px;
			margin-bottom: 20px;
			padding-top: 15px;
			box-sizing: border-box;
			color: #1979b7;
			font-size: 20px;
		}

		img {
			width: 20px;
			height: 20px;
			margin-right: 7px;
		}
	}

	.content {
		width: 914px;
		// padding: 0px 13%;
		padding: 0 150px;
		// min-height: 100vh;
		background-color: white;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;

		.box {
			width: 200px;
			height: 88px;
			background: #0175c2;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 30px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #ffffff;
		}
	}

	.line1 {
		width: 100%;
		height: 1px;
		background-color: #0175c2;
		animation: widthAni 2s linear infinite alternate;
		animation-iteration-count: 1;
	}

	.line2 {
		width: 100%;
		height: 1px;
		align-self: flex-end;
		background-color: #0175c2;
		animation: widthAni 2s linear infinite alternate;
		animation-iteration-count: 1;
	}

	.line_qm {
		width: 200px;
		height: 200px;
		align-self: flex-end;
		margin-right: -100px;
		position: relative;
	}

	.line_qm1 {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		border: #0175c2 solid 1px;
		border-radius: 100px;
	}

	.line_qm2 {
		width: 50%;
		height: 100%;
		background-color: white;
		position: absolute;
		top: 0;
		left: 0;
	}

	.line_qm3 {
		width: 101%;
		height: 0px;
		background-color: white;
		position: absolute;
		bottom: -1px;
		left: 0;
		animation: heightAni 2s linear infinite alternate;
		animation-iteration-count: 1;
	}

	.line_qw {
		width: 200px;
		height: 200px;
		margin-left: -100px;
		position: relative;
	}

	.line_qw1 {
		width: 200px;
		height: 200px;
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		border: #0175c2 solid 1px;
		border-radius: 100px;
	}

	.line_qw2 {
		width: 100px;
		height: 200px;
		background-color: white;
		position: absolute;
		top: 0px;
		right: -2px;
		bottom: 0px;
	}

	.line_qw3 {
		width: 200px;
		height: 0px;
		background-color: white;
		position: absolute;
		left: 0px;
		bottom: -1px;
		animation: heightAni 2s linear infinite alternate;
		animation-iteration-count: 1;
	}
}

.typeStyle {
	width: 150px;
	height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 20px;
	border: 1px solid #e5e5e5;
	border-bottom: none;
}

.typeStyle1 {
	background: #0175c2;
	color: #fff;
	border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue